import { Badge as AntBadge } from 'antd'

import styled from 'styled-components'
import { space } from 'styled-system'

const BadgeComponent = styled(AntBadge)`
  ${space};
`

export default BadgeComponent